function getTextForUserSelect(user) {
    var text = user.name;
    text += user.email ? " - " + user.email : "";
    return text;
}
function getInitials(name) {
    const hasTokens = name.indexOf(' ') !== -1
    return name.substring(0, hasTokens ? 1 : 2) + (hasTokens ? name.charAt(name.lastIndexOf(' ') + 1) : '')
}
var passwordRules = [
    (v) => (v && v.length >= 7) || "Password must be 8 characters long.",
    (v) => (v && /[A-Z]/.test(v)) || "Passwords must contain an uppercase letter.",
    (v) => (v && /[a-z]/.test(v)) || "Passwords must contain a lowercase letter.",
    (v) => (v && /\W/.test(v)) || "Passwords must contain a special character.",
    (v) => (v && /\d/.test(v)) || "Passwords must contain a number.",
]

export { getTextForUserSelect, getInitials, passwordRules}